import React from 'react';
import { Box, Typography } from '@mui/material';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import { colors, fonts, spacing } from '../../../constants';
import { formatFileSize } from '../../../utils/fileUtils';
import { getUploadZoneStyles, ICON_SIZES, IMPORT_COLORS, MAX_FILE_SIZE } from '../../../constants/importDialog';

/**
 * FileUploadZone Component
 * Drag and drop file upload area
 */
const FileUploadZone = ({
  selectedFile,
  dragActive,
  fileInputRef,
  onFileSelect,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  onClick,
}) => {
  return (
    <>
      <Typography
        variant="body2"
        sx={{
          fontWeight: fonts.weightSemiBold,
          color: colors.textPrimaryDark,
          fontSize: fonts.fontSizeSm,
        }}
      >
        Upload a CSV or Excel file to import users in bulk
      </Typography>

      <Box
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onClick={onClick}
        sx={getUploadZoneStyles(dragActive)}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              onFileSelect(file);
            }
          }}
          style={{ display: 'none' }}
        />
        <CloudUploadIcon
          sx={{
            fontSize: ICON_SIZES.UPLOAD_ICON,
            color: dragActive ? IMPORT_COLORS.YELLOW_ACTIVE : colors.textSecondary,
            mb: spacing.sm,
          }}
        />
        <Typography
          variant="body2"
          sx={{
            fontWeight: fonts.weightSemiBold,
            color: colors.textPrimaryDark,
            fontSize: fonts.fontSizeSm,
            mb: spacing.xs,
          }}
        >
          {selectedFile ? selectedFile.name : 'Click to upload or drag and drop'}
        </Typography>
        {selectedFile && (
          <Typography
            variant="caption"
            sx={{
              color: colors.textSecondary,
              fontSize: fonts.fontSizeXs,
            }}
          >
            {formatFileSize(selectedFile.size)}
          </Typography>
        )}
        {!selectedFile && (
          <Typography
            variant="caption"
            sx={{
              color: colors.textSecondary,
              fontSize: fonts.fontSizeXs,
            }}
          >
            CSV or Excel file (max {MAX_FILE_SIZE / (1024 * 1024)}MB)
          </Typography>
        )}
      </Box>
    </>
  );
};

export default FileUploadZone;
